import { mount } from 'svelte';
import './design-tokens.css';
import './styles.css';
import App from './App.svelte';

export default mount(App, { target: document.getElementById('app')! });
